export default "__VITE_ASSET__B_DREqs1__"